/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  TrackingEventInput
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Tracking Event
 */
export const createTrackingEvent = (
    trackingEventInput: MaybeRefOrGetter<TrackingEventInput>,
 signal?: AbortSignal
) => {
      trackingEventInput = toValue(trackingEventInput);

      return axiosClient<void>(
      {url: `/tracking_events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: trackingEventInput, signal
    },
      );
    }




export const getCreateTrackingEventMutationKey = () => ['createTrackingEvent'] as const;

export const getCreateTrackingEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrackingEvent>>, TError,CreateTrackingEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTrackingEvent>>, TError,CreateTrackingEventMutationVariables, TContext> => {

const mutationKey = getCreateTrackingEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrackingEvent>>, CreateTrackingEventMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTrackingEvent(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTrackingEventMutationResult = NonNullable<Awaited<ReturnType<typeof createTrackingEvent>>>
    export type CreateTrackingEventMutationBody = TrackingEventInput
    export type CreateTrackingEventMutationError = ErrorType<SchemaValidationErrorResponse>
    export type CreateTrackingEventMutationVariables = {data: TrackingEventInput}

    /**
 * @summary Create Tracking Event
 */
export const useCreateTrackingEvent = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrackingEvent>>, TError,CreateTrackingEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTrackingEvent>>,
        TError,
        CreateTrackingEventMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTrackingEventMutationOptions(options), queryClient);
    }
